<template>
  <div>
    <button type="button" class="overview-opener" @click="$emit('update:show', 1)" v-if="!show">
      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="20" fill="#fff">
        <rect width="28" height="3" y="16" rx="1.5"/>
        <rect width="32" height="3" y="8" rx="1.5"/>
        <rect width="28" height="3" rx="1.5"/>
      </svg>
      {{$root.__('My choices')}}
    </button>
    <div class="overview" :class="{ 'with-ranking': show === 'ranking' }">
      <div class="overview-container">
        <div class="overview-scroller" v-if="show === 'ranking'">
          <icon class="overview-avatar" name="dreambuddy" />
          <div class="overview-greeting" v-html="$root.__('ranking text')"></div>

          <div v-if="ranking.length" class="ranking">
            <img class="ranking-img" src="/assets/img/price.svg">
            <h2 class="editables-h2">{{$root.__('Your top 3')}}</h2>
            <div>
              <LikedProduct v-for="product in ranking" :product="product" :key="product.product" context="ranking" />
            </div>
          </div>
          <div v-else v-html="$root.__('ranking empty')"></div>

          <div class="liked-products">
            <h2 class="editables-h2" v-if="likedProducts.length">{{$root.__('Your likes')}}</h2>
            <div>
              <LikedProduct v-for="product in likedProducts" :product="product" :key="product.product" context="likes" />
            </div>
          </div>
        </div>
        <div class="overview-scroller" v-else>
          <div :class="editables.length ? 'hidden-mobile' : ''">
            <icon class="overview-avatar" name="dreambuddy" />
            <div class="overview-greeting" v-html="$root.__('sidebar greeting')"></div>
            <div class="overview-line"></div>
          </div>
          
          <p v-if="!inIframe">
            <a href="/bubble.html" target="_top">bubble</a><br>
            <a href="/kiosk.html" target="_top">kiosk</a><br>
            <a href="/test-nl.html" target="_top">Test pagina</a><br>
            <a href="/test-fr.html" target="_top">Français test</a>
          </p>

          <div class="liked-products">
            <h2 class="editables-h2" v-if="likedProducts.length">{{$root.__('Your likes')}}</h2>
            <div>
              <LikedProduct v-for="product in likedProducts" :product="product" :key="product.product" context="likes" />
            </div>
          </div>

          <div v-if="editables.length" class="editables">
            <h2 class="editables-h2">{{$root.__('Your choices')}}</h2>
            <div class="editable" v-for="r in editables" @click="redo(r)">
              <quick :r="r" />
              <button type="button" class="editable-btn"><icon name="pencil" /></button>
            </div>
          </div>
        </div>

        <div class="overview-line" v-if="editables.length || likedProducts.length"></div>

        <div class="overview-buttons">
          <MyButton @click="more" icon="arrow-left-bold" color="#00AEE8" v-if="show === 'ranking'">{{removeEmoji($root.__('Back'))}}</MyButton>
          <MyButton id="button-vouchers" :href="voucherUrl" icon="present" color="#005AA6" v-if="!$root.kiosk">{{removeEmoji($root.__('Cadeaukaart'))}}</MyButton>
          <MyButton id="button-restart" @click="restart" :icon="restartIcon" color="#E2260F">{{removeEmoji($root.__('Herstart'))}}</MyButton>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div class="overview-backdrop" v-if="show" @click="$emit('update:show', 0)"></div>
    </transition>
  </div>
</template>

<script>
import LikedProduct from './LikedProduct.vue'
import MyButton from './MyButton.vue'
import Quick from './Quick.vue'

import { chat } from '../chat.js'
import { removeEmoji } from '../util.js'

window.touchStarted = false
window.addEventListener('touchstart', function onTouchStart() {
  window.touchStarted = true
  document.body.classList.add('touchStarted')
  window.removeEventListener('touchstart', onTouchStart, false)
}, false)

export default {
  components: {
    LikedProduct,
    MyButton,
    Quick
  },
  props: {
    show: null
  },
  data () {
    return {
      emptyArray: [],
      perf: null,
      restartIcon: '<svg class="icon-svg" viewBox="-1 -1 24 24" xmlns="http://www.w3.org/2000/svg"><path class="fill-fg" fill="white" d="M11,4C13.05,4 15.09,4.77 16.65,6.33C19.78,9.46 19.77,14.5 16.64,17.64C14.81,19.5 12.3,20.24 9.91,19.92L10.44,17.96C12.15,18.12 13.93,17.54 15.24,16.23C17.58,13.89 17.58,10.09 15.24,7.75C14.06,6.57 12.53,6 11,6V10.58L6.04,5.63L11,0.68V4M5.34,17.65C2.7,15 2.3,11 4.11,7.94L5.59,9.41C4.5,11.64 4.91,14.39 6.75,16.23C7.27,16.75 7.87,17.16 8.5,17.45L8,19.4C7,19 6.12,18.43 5.34,17.65Z"></path></svg>'
    }
  },
  computed: {
    editables () {
      const out = []
      const { __, state } = this.$root
      if (state.occasion) {
        out.push(state.occasion)
      }
      if (state.gender) {
        out.push(state.gender)
      }
      if (state.name) {
        out.push({
          model: 'name',
          title: state.name
        })
      }
      if (state.age > -1) {
        out.push({
          model: 'age',
          title: __('age textual').replace('#', state.age)
        })
      } else if (state.age === -1) {
        out.push({
          model: 'age',
          title: __('all ages')
        })
      }
      if (state.budget) {
        let title = ''
        if (state.budget[0] > 0) {
          title += __('budget min text').replace('#', state.budget[0]) + ' '
        }
        if (state.budget[1] < 105) {
          title += __('budget max text').replace('#', state.budget[1])
        }
        if (!title) {
          title = __('any budget')
        }
        out.push({
          model: 'budget',
          title
        })
      }
      if (state.categories) {
        if (state.categories.length > 1) {
          out.push({
            model: 'categories',
            title: __('# categories').replace('#', state.categories.length)
          })
        } else if (state.categories.length === 1) {
          const translated = window.sharedCategories && window.sharedCategories.find(c => c.key === state.categories[0])
          const title = translated && translated[state.lang] || state.categories[0]
          out.push({
            model: 'categories',
            title
          })
        } else {
          out.push({
            model: 'categories',
            title: __('all categories')
          })
        }
      }
      return out
    },
    inIframe() {
      return window !== window.top && !this.$root.kiosk
    },
    likedProducts () {
      return (this.$root.state.likes || []).slice().reverse()
    },
    ranking () {
      return this.$root.user.ranking || this.emptyArray
    },
    voucherUrl () {
      return this.$root.state.lang === 'fr' ? 'https://vouchers.dreamland.be/fr/giftcards' : 'https://vouchers.dreamland.be/giftcards'
    }
  },
  methods: {
    removeEmoji,
    more () {
      this.$emit('update:show', 0)
    },
    redo (r) {
      this.$root.track({
        event_type: 'user_interaction',
        interaction_type: 'redo-' + r.model || r.fallback,
      })
      this.$emit('update:show', 0)
      chat.send({
        data: {},
        next: r.model || r.fallback
      })
    },
    restart () {
      this.$root.track({
        event_type: 'user_interaction',
        interaction_type: 'redo-restart',
      })
      this.$emit('update:show', 0)
      this.$root.restart()
    }
  },
  // mounted () {
  //   const mounted = Date.now()

  //   const h = window.location.host
  //   if (!h.indexOf('localhost') || !h.indexOf('test.') || h.indexOf('syst.') > -1) {
  //     getPerf().then(perf => {
  //       perf.mounted = mounted
  //       console.log('loadtime', perf.mounted - perf.scriptStart, 'ms')
  //     })
  //   }
  // },
  watch: {
    ranking (val, old) {
      if (val.length && val !== old) {
        this.$emit('update:show', 'ranking')
      }
    }
  }
}

function getPerf () {
  return new Promise(resolve => {
    window.addEventListener('message', function (evt) {
      if (evt.data.performance) {
        resolve(evt.data)
      }
    }, false)
    window.top.postMessage('perf', '*')
  })
}
</script>

<style>
.overview-opener {
  display: none;
  position: fixed;
  z-index: 3;
  left: 8px;
  bottom: 8px;
  margin: 0;
  border: 0;
  border-radius: 1.5em;
  padding: 1em 1.5em 1em 4.5em;
  font-family: Lilita One, chelsea market, sans-serif;
  font-size: 14px;
  line-height: .6em;
  text-shadow: 0 0 10px black;
  background: rgba(0, 0, 0, .1);
  color: white;
  transition: background .2s;
}
.overview-opener>svg {
  position: absolute;
  left: 20px;
  bottom: 7px;
}
.overview {
  position: fixed;
  z-index: 8;
  top: 0;
  left: 100%;
  right: -100%;
  width: 100%;
  height: 100%;
  max-height: 100%;
  transition: transform .3s;
  pointer-events: none;
}
.overview-container {
  position: relative;
  padding: 15px;
  max-width: 400px;
  margin: 0 auto;
  height: 100%;
  min-height: 50vh;
  background: white;
  color: black;
  pointer-events: all;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
}
.overview-show .overview-container {
  box-shadow: 0 0 4px rgba(0, 0, 0, .4),  0 0 9px rgba(0, 0, 0, .2);
}

@media (min-width: 400px) {
  .overview {
    right: -350px;
    width: 350px;
  }
}
@media (max-width: 999px) or (orientation: portrait) {
  .hidden-mobile {
    display: none;
  }
  .overview-backdrop {
    position: fixed;
    z-index: 7;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: black;
    opacity: .4;
  }
  .overview-opener {
    display: inline-block;
  }
  .overview-opener:focus {
    outline: none;
    background: rgba(0, 0, 0, .5);
  }
  .overview-show .overview {
    transform: translateX(-100%);
  }
}

@media (min-width: 1000px) and (orientation: landscape) {
  .only-mobile {
    display: none;
  }
  .overview-opener {
    display: none;
  }
  .overview {
    left: auto;
    right: 0;
    transform: none;
  }
  .overview-container {
    box-shadow: 0 0 4px rgba(0, 0, 0, .4), 0 0 9px rgba(0, 0, 0, .2);
    transition: transform .3s;
  }
  .fixed-border .overview-container {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  /*
  .with-products .overview-container {
    box-shadow: none;
    transform: translateX(100%);
  }
  .with-products .overview-opener {
    display: inline-block;
  }
  .with-products.overview-show .overview-container {
    box-shadow: 0 0 4px rgba(0, 0, 0, .4), 0 0 9px rgba(0, 0, 0, .2);
    transform: none;
  }
  */
}

.overview-scroller {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  margin: -15px;
  padding: 15px;
  overflow: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.overview-avatar {
  margin: 0 auto 1rem 0!important;
  font-size: 60px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
}
.overview-greeting h1 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 30px;
}
.overview-greeting .lead {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.6);
}
.overview-greeting p {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.4);
}
.overview-line {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  margin: 15px -15px;
}
.overview-buttons {
  margin: -5px -5px -5px;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-basis: auto;
  flex-shrink: 0;
  flex-grow: 0;
}
.overview-buttons>.btn {
  flex: 1 0 auto;
}
.with-ranking .btn {
  padding-top: 10px;
  padding-bottom: 6px;
}

.ranking {
  position: relative;
  margin: 3rem 0 1rem;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}
.ranking-img {
  position: absolute;
  left: calc(50% - 30px);
  top: -30px;
  border-radius: 50%;
  padding: 10px;
  width: 60px;
  height: 60px;
  background: white;
  box-shadow: 0px 2px 10px rgba(227, 164, 23, 0.35);
}

.hidden-mobile,
.liked-products,
.editables {
  flex-shrink: 0;
}
.editables-h2 {
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 18px;
  letter-spacing: 0.666667px;
  color: rgba(0, 0, 0, 0.4);
  margin-left: 2px;
}

.editable {
  margin-left: -.5em;
}
.editable-btn {
  margin: 0;
  border: none;
  padding: 0;
  max-width: 1em;
  overflow: hidden;
  font-size: 18px;
  background: none;
  opacity: .4;
  vertical-align: middle;
  -webkit-appearance: none;
  appearance: none;
}

button {
  cursor: pointer;
  user-select: none;
}
</style>
